module.exports = __webpack_public_path__ + "img/SC4-Debt.4aeb6125.png";